<template>
  <div class="new-project-header">
    <span class="title"> {{ $t('activity.log') }} </span>
    <v-btn class="new-project-button" color="primary" @click="newProjectClicked">
      {{ $t('projectsList.header.create.project') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'NewProjectHeader',
  methods: {
    newProjectClicked() {
      this.$emit('createProjectClicked');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.new-project-header {
  display: flex;
  justify-content: space-between;
  padding: 0 rem(86) rem(20) rem(32);

  .title {
    color: var(--text-primary);
    font-family: $font-family-bold;
    font-size: $font-size-2xl;
    font-weight: bold;
    line-height: rem(20);
    letter-spacing: 0;
    margin-bottom: $space-2;
  }
}
</style>
